import { type ImageRulesType } from 'utils/apiList/images'
import { type GetAllSegmentsResponseType } from 'features/CampaignAndDiscount/services/campaignAddManual'

export type MilestoneUserType = 'EARLY_USER' | 'RETURNING_USER'

export type MilestoneRewardType = 'VOUCHER'

export type MilestoneInjectionType = 'DIRECT_VOUCHER' | 'NEXT_TRANSACTION'

export type MilestoneUserSegmentType = GetAllSegmentsResponseType[number]

export type MilestoneCategoryFilterType = '' | 'EXCLUDE' | 'INCLUDE'

export type VoucherType = {
  voucher_id: number
  voucher_code: string
  benefit_type: string
  targeting_type: string
  mechanism_type: string
  minimum_purchase: number
  voucher_amount: number
  quota_all: number
  is_quota_unlimited: boolean
  coin_amount: number
  quota_redemption: number
  is_unlimited_redemption: boolean
  daily_quota: number
}

export type MilestoneUserTypeOptionType = {
  name: string
  value: MilestoneUserType
}

export type MilestoneInjectionTypeOptionType = {
  name: string
  value: MilestoneInjectionType
}

export enum MilestoneScheculeTypeEnum {
  NORMAL = 'NORMAL',
  REGISTRATION_DATE = 'REGISTRATION_DATE',
}

export type MilestoneGeneralFormType = {
  milestone_name: string
  milestone_title: string
  milestoneType: Nullable<MilestoneUserTypeOptionType>
  injectionType: Nullable<MilestoneInjectionTypeOptionType>
  segment: Nullable<MilestoneUserSegmentType>
  title_bg_color: string
  backgroundFile: Nullable<File>
  background_url: string
  startDate: string
  startTime: string
  endDate: string
  endTime: string
  scheduleType: MilestoneScheculeTypeEnum
  icon_umbrella_url: string
  icon_umbrella_file: Nullable<File>
  is_category_milestone: boolean
}

export type MilestoneSectionFormType = {
  minimum_purchase: string
  transaction_count: number
  reward_position: number
  reward_type: MilestoneRewardType
  reward: Nullable<VoucherType>
  category_filter_mode: MilestoneCategoryFilterType
  category_ids: string[]
  icon_child_url: string
  icon_child_file: Nullable<File>
}

export type MilestoneDetailFormType = {
  minimum_purchase: number
  transaction_count: number
  reward_position: number
  reward_type: string
  reward_id: number
}

export type TncSectionFormType = {
  tnc_title: string
  tnc_summary: string
  tnc_detail: string
}

export type InitialStateType = {
  isLoading: boolean
  general: {
    form: MilestoneGeneralFormType
    segmentOptions: MilestoneUserSegmentType[]
    backgroundImageRule: Nullable<ImageRulesType>
    iconImageRule: Nullable<ImageRulesType>
  }
  milestone: {
    list: MilestoneSectionFormType[]
    voucherOptions: VoucherType[]
    milestoneIndexToDelete: Nullable<number>
  }
  tnc: {
    form: TncSectionFormType
  }
  milestoneDetail: Nullable<MilestoneType>
}

export type MilestoneType = {
  id: number
  milestone_name: string
  milestone_title: string
  milestone_type: MilestoneUserType
  milestone_injection_type: MilestoneInjectionType
  segment_id: number
  segment_name: string
  title_bg_color: string
  background_url: string
  milestone_schedule_type: MilestoneScheculeTypeEnum
  start_time: number
  end_time: number
  tnc_title: string
  tnc_summary: string
  tnc_detail: string
  icon_child_url: string
  icon_umbrella_url: string
  milestone_details: {
    minimum_purchase: number
    transaction_count: number
    reward_position: number
    reward_type: MilestoneRewardType
    reward_id: number
    category_filter_mode: MilestoneCategoryFilterType
    icon_child_url: string
    category_ids: number[]
  }[]
  is_category_milestone: boolean
}

// Reducer payload type
export type SetGeneralFormPayloadType = {
  field: keyof MilestoneGeneralFormType
  value: MilestoneGeneralFormType[keyof MilestoneGeneralFormType]
}

export type SetMilestoneFormPayloadType = {
  index: number
  field: keyof MilestoneSectionFormType
  value: MilestoneSectionFormType[keyof MilestoneSectionFormType]
}

export type SetTncFormPayloadType = {
  field: keyof TncSectionFormType
  value: TncSectionFormType[keyof TncSectionFormType]
}

// API
export type GetVoucherResponseType = {
  content: VoucherType[]
}

export type MilestoneAddEditPayloadType = {
  milestone: {
    id?: number
    background_url: string
    end_time: number | string
    milestone_name: string
    milestone_title: string
    milestone_type: string
    milestone_injection_type: MilestoneInjectionType
    rewards: {
      reward_position: number
      minimum_purchase: string
      transaction_count: number
      reward_type: string
      reward_id: number
      category_filter_mode: string
      category_ids: string // commo separated ids
      icon_child_url: string
    }[]
    segment_id: number
    segment_name: string
    milestone_schedule_type: MilestoneScheculeTypeEnum
    start_time: Nullable<number | string>
    title_bg_color: string
    tnc_detail: string
    tnc_summary: string
    tnc_title: string
    is_category_milestone: boolean
  }
}

export type GetMilestoneDetailResponseType = MilestoneType
